import React, { useState } from 'react';
import { passwordRegex } from '../../../../assets/constants/strings';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordInput = ({ password, setPassword, isInvalid, id, label, disabled }) => {

  const [showPass, setShowPass] = useState(false);

  return (
    <div className="form-group mb-3 position-relative">
      <label htmlFor={id}>
        {label}
      </label>
      <input
        className={`form-control${isInvalid ? ' is-invalid' : password.length === 0 ? '' : (
          passwordRegex(password) ? ' is-valid' : ' is-invalid'
        )}`}
        type={showPass ? 'text' : 'password'}
        id={id}
        onChange={setPassword}
        value={password}
        required
        disabled={disabled}
      />
      {password.length > 0 ? (
        showPass ? (
          <FaEyeSlash className="password-visibility bottom" title="Hide Password" onClick={() => setShowPass(false)} />
        ) : (
          <FaEye className="password-visibility bottom" title="Show Password" onClick={() => setShowPass(true)} />
        )
      ) : null}
    </div>
  );
};

export default PasswordInput;
